require('../../../../_lib/jquery.passwordRequirements');

$(() => {
  $('.pr-password').passwordRequirements();
});
